var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MenuSousMenu',{staticClass:"menu_statuses condensed no-bold no-margin",attrs:{"disabled":!_vm.isActive,"settings":_vm.menu_statuses,"tooltip_length":_vm.tooltip_length,"maxheight":260}})
}
var staticRenderFns = []

export { render, staticRenderFns }